import Vue from 'vue';
import _ from 'lodash';
export default {
    state: {
        // 板甲（即：把Course/index页面的需要公用的数据写在这里，比如页面里的loading）
        dashboard: {
            loading: false,
            courseId: '' // 课程id
        },
        // 头部
        header: {},
        // 侧边栏
        sideBar: {},
        // 内容
        main: {
            // 课程名称
            courseName: {
                // 课节详情
                keJieDetail: {
                    id: '', // 课节ID
                    name: '', // 课节名称
                    order: '', // 第几节课
                    teacherId: '', // 教师ID(待删除，其它区块可从user模块中读取)
                    teacherUsername: '', // 教师用户名(待删除，其它区块可从user模块中读取)
                    teacherName: '', // 教师名称(待删除，其它区块可从user模块中读取)
                    studentId: '', // 学生ID(待删除，其它区块可从router中读取)
                    studentName: '', // 学生姓名
                    startTime: '', // 开始时间
                    endTime: '' // 结束事件
                }
            },
            // 基础评价
            basicEvaluation: {
                attend: 0, // 学生出勤情况
                networkCondition: 1, // 课堂网络连接情况
                lastHomeworkProcess: 0, // 作业完成情况
                lastHomeworkAccuracyPercentage: 0, // 作业准确率
                lessonReportUrl: '', // 课后报告地址
                capsuleStatus: '', // 选择已讲完，未讲完
                capsuleId: '' // 已选胶囊ID

            },
            // 综合评价
            generalEvaluation: {
                comprehensionAcceptance: 0,
                concentration: 0,
                suggestion: '',
                commentsTemplateNo: undefined
            },
            // 本节课知识点
            courseContent: {
                isConditionEmpty: false, // 是否有知识点的掌握情况为空
                knowledgeLength: 0,
                planId: '' // 课程对应规划id，无则不返回
            },
            // 后续课程规划
            flowCoursePlan: {
                remainFormalLessonNum: 0, // 后续课程数量，为0时不展示后续课程组件 // 一直展示课程组件
                lessonPlanLists: [], // 后续课程列表
                isHaveLearningPlan: false,
                smartPlanId: ''
            },
            // 知识点
            points: [],
            planName: [],
            planIdList: [],
            lessonInfo: []
        }
    },
    getters: {
        getNextIsEmpty: state => {
            if (state.main.flowCoursePlan.lessonPlanLists.length) {
                return !state.main.flowCoursePlan.lessonPlanLists[0].name;
            }
            return false;
        }
    },
    mutations: {
        'main.basicEvaluation.set'(state, { type, value }) {
            state.main.basicEvaluation[type] = value;
        },
        'main.generalEvaluation.set'(state, { type, value }) {
            state.main.generalEvaluation[type] = value;
        },
        'main.courseContent.set'(state, { type, value }) {
            state.main.courseContent[type] = value;
        },
        'main.courseContent.knowledgeLength.set'(state, value) {
            state.main.courseContent.knowledgeLength = value;
        },
        // 后续课程处理数据
        'main.flowCoursePlan.handleData'(state, { courseData, nowOrder, smartPlanId }) {
            const num = courseData.remainFormalLessonNum > 3 ? 3 : courseData.remainFormalLessonNum;
            state.main.flowCoursePlan.smartPlanId = smartPlanId;
            console.log(state.main.flowCoursePlan.smartPlanId, smartPlanId, 'smartPlanId');
            state.main.flowCoursePlan.remainFormalLessonNum = num;
            state.main.flowCoursePlan.lessonPlanLists = [];
            for (let i = 0; i <= 3; i++) {
                let currentOrder = nowOrder + i;
                let obj = {};
                let index = _.findIndex(courseData.learningPlanInfo, {order: currentOrder});
                if (index < 0) {
                    obj = {
                        order: currentOrder,
                        name: '',
                        editName: '',
                        isEdit: true
                    };
                } else {
                    obj = courseData.learningPlanInfo[index];
                    obj.isFromLearningPlan = false;
                    obj.name = courseData.learningPlanInfo[index].name;
                    obj.isEdit = false;
                    if (courseData.learningPlanInfo[index].capsuleId) {
                        obj.capsuleId = courseData.learningPlanInfo[index].capsuleId;
                        obj.capsuleStatus = courseData.learningPlanInfo[index].capsuleStatus || '';
                    }
                }
                state.main.flowCoursePlan.lessonPlanLists.push(obj);
            }
        },
        // 后续课程处理点击编辑
        'main.flowCoursePlan.edit'(state, order) {
            state.main.flowCoursePlan.lessonPlanLists.forEach((item) => {
                if (item.order === order) {
                    item.isEdit = true;
                }
            });
        },
        // 后续课程点击确认接口成功后调用
        'main.flowCoursePlan.successSubmit'(state, order) {
            state.main.flowCoursePlan.lessonPlanLists.forEach((item) => {
                if (item.order === order) {
                    item.name = item.editName.trim();
                    item.isEdit = false;
                    item.isFromLearningPlan = false;
                }
            });
        },
        // 后续课程点击取消
        'main.flowCoursePlan.cancel'(state, order) {
            state.main.flowCoursePlan.lessonPlanLists.forEach((item) => {
                if (item.order === order) {
                    item.editName = item.name;
                    item.isEdit = false;
                }
            });
        },
        // 后续课程输入框变更
        'main.flowCoursePlan.nameChange'(state, { value, order }) {
            state.main.flowCoursePlan.lessonPlanLists.forEach((item) => {
                if (item.order === order) {
                    item.editName = value;
                }
            });
        },
        // 学生规划列表
        'main.flowCoursePlan.planData'(state, planData) {
            let planTemp = planData.list.filter(item => !item.isFinish);
            if (planTemp.length) {
                state.main.flowCoursePlan.isHaveLearningPlan = true;
                planTemp.forEach((item, index) => {
                    state.main.planName.push(item.name);
                    state.main.planIdList.push(item.planId);
                    item.books.forEach(it => {
                        if (!state.main.points[index]) {
                            state.main.points[index] = [];
                        }
                        state.main.points[index].push(...it.points);
                    });
                });
            }
        },
        // 学生课程详情
        'main.lessonInfo.set'(state, lessonInfo) {
            state.main.lessonInfo = lessonInfo;
        }
    },
    actions: {
        /**
         * @param {object} {studentId:学生id，teacherId:老师id}
         * @desc 获取课程id，然后保存
         * */
        'dashboard.getCourseId'({ state }, { studentId, teacherId }) {
            const params = { params: { teacherId, studentId } };
            return Vue.http.get('/v1/courses/id', params).then(({ data }) => {
                if (data) {
                    state.dashboard.courseId = data.courseId;
                }
            });
        },
        /**
         * @desc header区块的提交按钮事件
         * */
        'header.globalSubmit'(ctx, lessonId) {
            const {
                main: {
                    courseName,
                    generalEvaluation,
                    basicEvaluation,
                    courseContent,
                    flowCoursePlan
                }
            } = ctx.state;
            const { $message } = Vue.prototype;
            // 提交前校验
            const checkGlobalSubmit = function() {
                flowCoursePlan.learningPlanInfo = flowCoursePlan.lessonPlanLists.filter(item => {
                    return item.isEdit === false && item.name !== '';
                });
                if (!courseName.keJieDetail.name) {
                    $message.error('课程名称不能为空');
                    return false;
                }
                if (!(generalEvaluation.suggestion || '').trim()) {
                    $message.error('本节课评语不能为空');
                    return false;
                }
                if (generalEvaluation.suggestion.trim().length < 5) {
                    $message.error('【本节课评语不足5字，请重新填写】');
                    return false;
                }

                if (basicEvaluation.lastHomeworkProcess === 1 || basicEvaluation.lastHomeworkProcess === 2) {
                    if (!basicEvaluation.lastHomeworkAccuracyPercentage) {
                        $message.error('存在未勾选的基础评价，请勾选后提交');
                        return false;
                    }
                }
                if (basicEvaluation.lastHomeworkProcess === 5) {
                    Reflect.deleteProperty(basicEvaluation, 'lastHomeworkProcess');
                }
                if (courseContent.knowledgeLength === 0) {
                    $message.error('【本节课知识点为空，请添加后提交】');
                    return false;
                }
                if (courseContent.isConditionEmpty) {
                    $message.error('本节课知识点中存在选择掌握情况的知识点，请完善后提交');
                    return false;
                }
                if (ctx.getters.getNextIsEmpty) {
                    $message.error('本节课名称不能为空');
                    return false;
                }
                if (flowCoursePlan.learningPlanInfo.length < 2 || flowCoursePlan.learningPlanInfo[1].order !== flowCoursePlan.learningPlanInfo[0].order + 1) {
                    $message.error('下节课名称不能为空');
                    return false;
                }
                if (!flowCoursePlan.learningPlanInfo[0].capsuleId && flowCoursePlan.smartPlanId) {
                    $message.error('当前胶囊不能为空,请重新编辑当前课程');
                    return false;
                }
                if ((!flowCoursePlan.learningPlanInfo[0].capsuleStatus) && flowCoursePlan.smartPlanId) {
                    $message.error('是否完成授课不能为空');
                    return false;
                }
                return true;
            };
            // 发送请求
            const postSubmitRequest = function() {
                const params = {
                    ...generalEvaluation,
                    ...basicEvaluation
                };
                for (let key in params) {
                    if (params.hasOwnProperty(key) === true) {
                        if (params[key] === 0) {
                            delete params[key];
                        }
                    }
                }

                params.courseId = ctx.state.dashboard.courseId;

                params.learningPlanInfos = flowCoursePlan.lessonPlanLists.filter(item => {
                    return item.isEdit === false && item.name !== '';
                });
                params.smartPlanId = flowCoursePlan.smartPlanId;
                params.capsuleId = params.learningPlanInfos[0].capsuleId;
                params.capsuleStatus = params.learningPlanInfos[0].capsuleStatus;
                console.log(params, 'params');
                return Vue.http.post(`/v1/formal-lessons/${lessonId}/lesson-journal`, params);
            };
            if (checkGlobalSubmit()) {
                return postSubmitRequest().then(resp => Vue.checkResp(resp, {}));
            }
            return Promise.reject('验证不通过');
        },
        /**
         * @param {string} lessonId:课节id
         * @desc 获取课节详情
         * */
        'main.courseName.getKeJieDetail'({ state }, lessonId) {
            return Vue.http.get(`/v1/formal-lessons/${lessonId}`).then(({ data }) => {
                if (data) {
                    state.main.courseName.keJieDetail = data;
                }
            });
        },
        // 获取正式课日志(new)--课程日志页面

        // 获取正式课老师综合评
        COURSELOG_GET_JOURNAL({ commit }, { lessonId, isView }) {
            if (isView) {
                Vue.http.get(`/v1/formal-lessons/${lessonId}/whole-judgement`)
                    .then(resp => Vue.checkResp(resp, {}))
                    .then(data => {
                        commit('main.generalEvaluation.set', {
                            type: 'concentration',
                            value: data.concentration || 3
                        });
                        commit('main.generalEvaluation.set', {
                            type: 'comprehensionAcceptance',
                            value: data.comprehensionAcceptance || 3
                        });
                        commit('main.generalEvaluation.set', {
                            type: 'suggestion',
                            value: data.suggestion || ''
                        });
                    });
            }
            // 获取正式课程日志
            // http://wiki.iyunxiao.com/pages/viewpage.action?pageId=146571597#hfsfd-teacher%E6%AD%A3%E5%BC%8F%E8%AF%BEAPI-%E8%8E%B7%E5%8F%96%E6%AD%A3%E5%BC%8F%E8%AF%BE%E6%97%A5%E5%BF%97(new)
            return Vue.http.get(`/v1/formal-lessons/${lessonId}/lesson-journal`)
                .then(resp => Vue.checkResp(resp, {}))
                .then(data => {
                    if (!isView) {
                        // 综合评价
                        commit('main.generalEvaluation.set',
                            {
                                type: 'concentration',
                                value: data.concentration || 3
                            }
                        );
                        commit('main.generalEvaluation.set',
                            {
                                type: 'comprehensionAcceptance',
                                value: data.comprehensionAcceptance || 3
                            }
                        );

                        commit('main.generalEvaluation.set',
                            {
                                type: 'suggestion',
                                value: data.suggestion || ''
                            }
                        );
                        commit('main.generalEvaluation.set',
                            {
                                type: 'commentsTemplateNo',
                                value: data.commentsTemplateNo
                            }
                        );
                    }
                    // 基础评价
                    commit('main.basicEvaluation.set',
                        {
                            type: 'attend',
                            value: data.attend || 0
                        }
                    );
                    // you网络状况networkCondition
                    commit('main.basicEvaluation.set',
                        {
                            type: 'networkCondition',
                            value: data.networkCondition || 0
                        }
                    );
                    // you 上次作业完成情况homeworkProcess
                    commit('main.basicEvaluation.set',
                        {
                            type: 'lastHomeworkProcess',
                            value: data.lastHomeworkProcess || 0 // 新接口更改字段
                        }
                    );
                    // you  上次作业完成正确率lastHomeworkAccuracyPercentage
                    commit('main.basicEvaluation.set',
                        {
                            type: 'lastHomeworkAccuracyPercentage',
                            value: data.lastHomeworkAccuracyPercentage || 0 // 新接口更改字段
                        }
                    );
                    // 课后报告url
                    commit('main.basicEvaluation.set',
                        {
                            type: 'lessonReportUrl',
                            value: data.lessonReportUrl || ''
                        }
                    );
                    commit('main.basicEvaluation.set',
                        {
                            type: 'capsuleId',
                            value: data.capsuleId || ''
                        }
                    );
                    commit('main.basicEvaluation.set',
                        {
                            type: 'capsuleStatus',
                            value: data.capsuleStatus || ''
                        }
                    );
                })
                .catch(err => {
                    Vue.handleError(err);
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_courseLog.js